var _style, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgApplication(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 800 800",
    style: {
      enableBackground: "new 0 0 800 800"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#21252C;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M636.7,450H750c27.3,0,50,22.7,50,50v250c0,27.3-22.7,50-50,50H500c-27.3,0-50-22.7-50-50V500 c0-27.3,22.7-50,50-50h88.3v-29.7H210.9V450H300c27.3,0,50,22.7,50,50v250c0,27.3-22.7,50-50,50H50c-27.3,0-50-22.7-50-50V500 c0-27.3,22.7-50,50-50h112.5v-46.9c0-17.2,21.9-25.8,41.4-25.8h171.9v-28.1H268c-27.3,0-50-22.7-50-50v-250c0-27.3,22.7-50,50-50 h250c27.3,0,50,22.7,50,50v250c0,27.3-22.7,50-50,50h-92.2v28.9c64.8,0,104.7-0.8,169.5-0.8c19.5,0,41.4,7.8,41.4,25.8V450z  M750,500H500v250h250V500z M518,49.2H268v250h250V49.2z M300,500H50v250h250V500z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplication);
export default __webpack_public_path__ + "static/media/application.09e0877939df8f3256de8d62dce52805.svg";
export { ForwardRef as ReactComponent };